<template>
  <div style="min-height: 30vh;margin: 10px 20px;max-height: 70vh;">
    <ul style="width: 100%;" v-if="listData.length > 0">
      <li :key="item.id" style="margin-left:10%;margin-top: 5px;width: 40%;float: left;list-style: none;"
          v-for="(item,index) in listData">
        {{ index + 1 }}. {{ item.name }}
      </li>
    </ul>
    <div style="text-align: center;line-height: 30vh" v-else>暂无数据</div>
  </div>
</template>
<script>
import {listByModelIdAndDeviceId} from "@/network/device-model-control";

export default {
  name: "ShowControlList",
  props: {
    deviceInfo: {},
    dialogData: null,
  },
  data() {
    return {
      listData: [],
      form: {
        name: this.deviceInfo.name,
        note: this.deviceInfo.note
      }
    }
  },
  mounted() {
    this.listData = []
    this.getControlList();
  },
  methods: {
    getControlList() {
      listByModelIdAndDeviceId(this.deviceInfo.modelId, this.deviceInfo.id).then(res => {
        if (res.code === 0) {
          this.listData = res.data.modelControls
        }
      })
    },
  },
}
</script>

<style scoped>

</style>
